// Library Methods
import { useContext } from "react";
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeadsetFitCard from "../shared/HeadsetFitCard";
import SummarySection from "./SummarySection/SummarySection";

// Contexts
import { ReportSectionContext } from "src/contexts/reports/ReportSectionContext";

const StereopsisGraph = () => {
  const { t } = useTranslation();
  const { examReport } = useContext(ReportSectionContext);

  const stereoLadder = examReport?.postProcessing?.summary?.StereoLadder;

  if (!stereoLadder) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center" }}>
        <Typography fontSize="14px" fontWeight={600} color="#E10C0C">
          {t("No Data Available.")}
        </Typography>
      </Box>
    );
  }

  const calibration = examReport?.postProcessing?.calibration;
  const eyeModel = examReport?.postProcessing?.eyeModel;

  return (
    <Box display="flex" flexDirection="column" width="100%" gap="8px">
      {/* The headset leads, as on every other section. */}
      <HeadsetFitCard
        residualDegrees={calibration?.residualDegrees}
        qualityFloorMet={calibration?.qualityFloorMet}
        interpupillaryDistanceMetres={eyeModel?.interpupillaryDistanceMetres}
        interpupillaryDistanceMeasured={
          eyeModel?.interpupillaryDistanceMeasured
        }
      />
      <SummarySection
        summary={examReport?.postProcessing?.summary}
        stereoLadderModule={examReport?.postProcessing?.modules?.StereoLadder}
      />
    </Box>
  );
};

export default StereopsisGraph;
